import { useEmailSettings } from '@/state/notifications/useEmailSettings';
import { NotificationMatrix } from './NotificationMatrix';

/**
 * The signed-in user's own email preferences.
 *
 * Personal rather than account-wide, and on the personal settings screen for that
 * reason: it is their inbox, and nobody - not even an Owner - signs a colleague up
 * for mail. What reaches the organisation's Slack channel is the other screen.
 */
export const EmailNotifications = () => {
  const { settings, isLoading, isSaving, toggle } = useEmailSettings();

  return (
    <section className="bg-panel border-line rounded-panel border">
      <div className="border-line border-b px-4 py-3">
        <h2 className="text-foreground m-0 text-body font-medium">Email notifications</h2>
        <p className="supporting m-0 mt-1">
          Choose what reaches your inbox. Everything still appears in your notifications panel either way.
        </p>
      </div>
      <div className="p-4">
        <NotificationMatrix settings={isLoading ? undefined : settings} onToggle={toggle} disabled={isSaving} />
      </div>
    </section>
  );
};
